import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-credenciados',
  templateUrl: './credenciados.component.html',
  styleUrls: ['./credenciados.component.css']
})
export class CredenciadosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
